import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Icon, IconButton, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@material-ui/core';
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux';
import classNames from 'classnames';
import * as Actions from './store/actions';
import { bindActionCreators } from 'redux';
import ReactPlayer from 'react-player';

import Typography from '@material-ui/core/Typography';
import Slider from '@material-ui/lab/Slider';


const styles = theme => ({
    spacer: {
        marginTop: 25,
        marginBottom: 25
    },
    imgSizer: {
        maxHeight: 220
    },
    largeIcon: {
        fontSize: '72px!important',
        width: 100,
        height: 100,
    },
    large: {
        width: 120,
        height: 120,
        padding: 30,
    },
    sliderLabel: {
        fontSize: 16,
        paddingTop: '4px'
    }
});

class AssetImagePreview extends Component {

    constructor(props) {
        super(props);
        this.playerRef = React.createRef();
        this.props.getVideoProgress(this.props.asset_id, this.props.auth.user.data.auth_id)
    }

    state = {
        playing: false,
        volume: .5,
        completed: 0,
        fullScreenDialog: false
    }

    componentWillUnmount = () => {
        if (this.props.full_page && !this.props.videoCompleted) {
            this.props.createVideoProgress(this.props.asset_id, this.props.auth.user.data.auth_id, parseInt(this.state.playedSeconds), this.state.completed)
        }
    }

    handleSliderChange = (event, value) => {

        if (this.props.videoCompleted != 1 && this.state.completed === 0) {
            if (value < this.state.played * 100) {
                this.setState({ sliderValue: value })
                this.playerRef.current.seekTo(parseFloat(value / 100))
            }
        }
        else {
            this.setState({ sliderValue: value })
            this.playerRef.current.seekTo(parseFloat(value / 100))
        }


    }

    handleVolumeChange = (event, value) => {
        this.setState({ volume: value / 100 })
    }

    syncProgress = () => {
        this.props.videoCompleted === 0 ? this.playerRef.current.seekTo(parseFloat(this.props.videoProgress)) : this.playerRef.current.seekTo(parseFloat(0))
    }

    onProgress = (state) => {
        this.setState(state)
    }

    // testSeek = (seek) => {
    //     console.log(seek)
    //     console.log(this.state.playedSeconds)
    //     if (seek > this.state.playedSeconds) {
    //         console.log('forward')
    //         this.playerRef.current.seekTo(parseFloat(this.state.playedSeconds / 100))
    //         this.setState({ played: this.state.played, playedSeconds: this.state.playedSeconds })
    //     }
    // }

    playToggle = () => {
        if (this.state.playing) {
            this.setState({ playing: false })
        }
        else {
            this.setState({ playing: true })
        }
    }
    addzero = (number) => {
        if (number.toString().length === 1) {
            return "0" + number
        }
        return number
    }

    handleDialogToggle = (setting) => {
        const beforeSwitchPlayed = this.state.played
        this.props.resetVideoProgress(beforeSwitchPlayed)
        this.setState({ fullScreenDialog: setting })
    }

    render() {
        const { asset_url, classes } = this.props
        // console.log(this.state)

        if (this.state.loadedSeconds) {
            var minutes = Math.floor(this.state.playedSeconds / 60)
            var seconds = this.state.playedSeconds - minutes * 60
            var totalSecondsRaw = this.state.playedSeconds / this.state.played
            var totalMinutes = Math.floor(totalSecondsRaw / 60)
            var totalSeconds = totalSecondsRaw - totalMinutes * 60
        }

        if (this.state.played > .99 && this.state.completed === 0) {
            this.setState({ completed: 1 })
        }



        const player =
            // <Grid container spacing={16}>
            //     <Grid item xs={2}></Grid>
            //     <Grid item xs={8}>
            <div>
                <ReactPlayer ref={this.playerRef}
                    controls={false}
                    url={asset_url}
                    onStart={() => this.syncProgress()}
                    onProgress={this.onProgress}
                    volume={this.state.volume}
                    playing={this.state.playing}
                    width={this.state.fullScreenDialog ? '90%' : '640px'}
                    height={this.state.fullScreenDialog ? '50%' : '360px'}
                // controls={true}
                // onSeek={false}
                />

                <Grid container spacing={16}>
                    <Grid item xs={2}>
                        {seconds ? <span style={{ fontSize: 16, marginTop: 12 }}>{parseInt(minutes)}:{this.addzero(parseInt(seconds))} / {parseInt(totalMinutes)}:{this.addzero(parseInt(totalSeconds))}</span> : <span style={{ fontSize: 16 }}>0:00 / 0:00</span>}
                        <IconButton
                            className={classNames(classes.largeIcon)}
                            // iconStyle={styles.largeIcon}
                            style={styles.large}
                            onClick={this.playToggle}
                        >
                            {this.state.playing ? <Icon style={{ fontSize: '72px' }}> pause_circle_filled </Icon> : <Icon style={{ fontSize: '72px' }}> play_circle_filled </Icon>}

                        </IconButton>
                    </Grid>
                    <Grid item xs={7}>
                        <Typography className={classNames(classes.sliderLabel)} id="seekLabel">Seek</Typography>
                        <Slider aria-labelledby="seekLabel" value={this.state.played * 100} aria-labelledby="label" onChange={(event, value) => this.handleSliderChange(event, value)} style={{ width: '100%' }} />
                        <Typography className={classNames(classes.sliderLabel)} id="volumeLabel">Volume</Typography>
                        <Slider aria-labelledby="volumeLabel" value={this.state.volume * 100} aria-labelledby="label" onChange={(event, value) => this.handleVolumeChange(event, value)} style={{ width: '100%' }} />
                    </Grid>
                    <Grid style={{ marginTop: '20px' }} item xs={2}>
                        {this.state.fullScreenDialog ?
                            <IconButton
                                onClick={() => this.handleDialogToggle(false)}
                            >
                                <Icon style={{ fontSize: '60px' }} >fullscreen_exit</Icon>
                            </IconButton>
                            :
                            <IconButton
                                onClick={() => this.handleDialogToggle(true)}
                            >
                                <Icon style={{ fontSize: '60px' }} >fullscreen</Icon>
                            </IconButton>
                        }

                    </Grid>
                </Grid>
                {/* //     </Grid> */}
            </div>

        // </Grid>

        const fullScreenDialog =
            <Dialog
                open={this.state.fullScreenDialog}
                onBackdropClick={() => this.handleDialogToggle(false)}
                // maxWidth={'lg'}
                fullScreen={true}
                fullWidth={true}
                // open={true}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    <Grid container spacing={16}>
                        <Grid item xs={1}></Grid>
                        <Grid item xs={10}>{this.state.fullScreenDialog ? player : null}</Grid>
                    </Grid>

                </DialogContent>
            </Dialog >

        if (this.props.full_page) {
            return (
                <div>
                    {fullScreenDialog}
                    <Grid container spacing={16}>
                        <Grid item xs={3}></Grid>
                        <Grid item xs={6}>

                            {this.state.fullScreenDialog ? null : player}

                        </Grid>
                    </Grid>

                </div>
            )
        }

        else {
            return (
                <div className={classNames(classes.spacer)}>
                    <ReactPlayer
                        ref={this.playerRef}
                        controls={true}
                        url={asset_url}
                        width={200}
                        height={200}
                        onStart={() => this.syncProgress()}
                        onProgress={this.onProgress}
                    />
                </div>
            )
        }
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        createVideoProgress: Actions.createVideoProgress,
        getVideoProgress: Actions.getVideoProgress,
        resetVideoProgress: Actions.resetVideoProgress
    }, dispatch);
}

function mapStateToProps({ auth, assetApp }) {
    return {
        videoProgress: assetApp.assets.videoProgress,
        videoCompleted: assetApp.assets.videoCompleted,
        auth
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(AssetImagePreview)));


// WEBPACK FOOTER //
// src/main/content/asset/AssetVideoPreview.js